(function () {
  const productCache = new Map();
  const pendingRequests = new Map();

  function htmlParser(htmlText) {
    const template = document.createElement("template");
    template.innerHTML = htmlText;
    return template.content;
  }

  async function fetchProductData(ajaxURL) {
    if (productCache.has(ajaxURL)) {
      return productCache.get(ajaxURL);
    }
    if (pendingRequests.has(ajaxURL)) {
      return pendingRequests.get(ajaxURL);
    }
    const request = (async () => {
      try {
        const response = await fetch(ajaxURL);
        const htmlText = await response.text();
        const parsedHTML = htmlParser(htmlText);
        const productJSONTxt = parsedHTML.querySelector(`#${PRODUCT_CARD_2.PRODUCT_DETAILS_JSON_ID}`)?.textContent;
        const productJSON = productJSONTxt ? JSON.parse(productJSONTxt) : null;
        if (productJSON) {
          productCache.set(ajaxURL, productJSON);
          if (productCache.size > 200) {
            const oldestKey = productCache.keys().next().value;
            productCache.delete(oldestKey);
          }
        }
        return productJSON;
      } catch (e) {
        console.log(e);
        return null;
      } finally {
        pendingRequests.delete(ajaxURL);
      }
    })();

    pendingRequests.set(ajaxURL, request);

    return request;
  }

  function prefetchProductData(swatchEl) {
    const productURL = swatchEl.dataset.url;

    if (!productURL) return;
    const url = `${productURL}?section_id=${PRODUCT_CARD_2.SECTION_ID}`;

    if (productCache.has(url)) return;

    fetchProductData(url);
  }

  function updateQuickATC(url, quickAtcBtn){
    if (!url || !quickAtcBtn){
      return;
    }
    quickAtcBtn.dataset.overlayUrl = `${url.split("?")[0]}?section_id=product-card-2-quick-add-to-cart-ajax`
  }

  function updateOrCreatePrice(price, ProductPriceWrapperDOM, productSalePriceWrapperDOM, productSalePriceDOM, productOriginalPriceWrapperDOM, productOriginalPriceDOM, productDiscountWrapperDOM, productDiscountDOM) {
    const { salePrice, originalPrice, discount } = price;
    if (salePrice) {
      if (productSalePriceWrapperDOM && productSalePriceDOM) {
        productSalePriceDOM.textContent = salePrice;
      } else {
        ProductPriceWrapperDOM?.insertAdjacentHTML("beforeend",
          `<span class="product-card-2__sale-price-wrapper">
            <span class="tw-hidden">Sale price</span>
            <span class="product-card-2__sale-price ${discount ? "tw-text-brand-primary" : "tw-text-text-neutral-100"}">${salePrice}</span>
          </span>`);
      }
    } else {
      if (productSalePriceWrapperDOM && productSalePriceDOM) {
        productSalePriceWrapperDOM.remove();
      }
    }

    if (originalPrice) {
      if (productOriginalPriceWrapperDOM && productOriginalPriceDOM) {
        productOriginalPriceDOM.textContent = originalPrice;
      } else {
        ProductPriceWrapperDOM?.insertAdjacentHTML("beforeend",
          `<span class="product-card-2__original-price-wrapper">
            <span class="tw-hidden">Original price</span>
            <s class="product-card-2__original-price tw-font-primary tw-text-text-neutral-60">${originalPrice}</s>
          </span>`);
      }
    } else {
      if (productOriginalPriceWrapperDOM && productOriginalPriceDOM) {
        productOriginalPriceWrapperDOM.remove();
      }
    }

    if (discount) {
      if (productDiscountWrapperDOM && productDiscountDOM) {
        productDiscountDOM.textContent = discount;
      } else {
        ProductPriceWrapperDOM.insertAdjacentHTML("beforeend",
          `<span class="product-card-2__discount-wrapper">
          <span class="tw-hidden">Discount</span>
          <span class="product-card-2__discount tw-self-center tw-text-[#c41320] tw-text-[10px] md:tw-text-[14px]">${discount}</span>
        </span>`);
      }
    } else {
      if (productDiscountWrapperDOM && productDiscountDOM) {
        productDiscountWrapperDOM.remove();
      }
    }
  }

  function udpatedOrCreateLabels(labels, productNewLabelDOM, productRedloopLabelDOM, productLabelsWrapper) {
    const { renderNewLabel, renderRedloopLabel } = labels;
    updateNewLabel(renderNewLabel, productNewLabelDOM, productLabelsWrapper);
    updateRedloopLabel(renderRedloopLabel, productRedloopLabelDOM, productLabelsWrapper);
  }

  function updateNewLabel(renderNewLabel, productNewLabelDOM, productLabelsWrapper) {
    if (renderNewLabel) {
      if (productLabelsWrapper && !productNewLabelDOM) {
        if (productLabelsWrapper?.dataset?.renderNewLabel == "true"){
          productLabelsWrapper.insertAdjacentHTML("afterbegin",
            `<div class="product-card-2-labels__new-label tw-absolute tw-top-[3px] tw-left-[3px] tw-leading-[0] tw-h-[14px] tw-flex tw-items-center">
            <span class="tw-bg-[#fff] tw-text-[#000] tw-text-[7px] lg:tw-text-[10px] tw-leading-none tw-px-[2px] tw-px-[6px] tw-flex tw-items-center tw-h-full tw-w-full">NEW</span>
            <span class="tw-h-full tw-border-t-[7px] tw-border-t-[#fff] tw-border-b-[7px] tw-border-b-[#fff] tw-border-r-[8px] tw-border-r-[transparent]" aria-hidden="true" role="presentation"></span>
            </div>`
          );
        }
      }
    } else {
      productNewLabelDOM?.remove();
    }
  }
  
  function updateRedloopLabel(renderRedloopLabel, productRedloopLabelDOM, productLabelsWrapper){
    if (renderRedloopLabel){
      if (productLabelsWrapper && !productRedloopLabelDOM) {
        productLabelsWrapper.insertAdjacentHTML("afterbegin",
          `<div class="product-card-2-labels__redloop-label tw-absolute tw-top-[3px] tw-left-[3px] tw-leading-[0]">
            <img
              src="https://levi.in/cdn/shop/files/REDLOOP_LOGO_SVG.svg?v=1789124004&width=240"
              alt="Redloop"
              width="240"
            >
          </div>
          `
        );
      }
    }else{
      productRedloopLabelDOM?.remove()
    }
  }

  function udpatedOrCreateRvBadges(labels, rvProductNewBadgeDOM, rvProductBadgesWrapper, productUnitsSoldWrapperDOM, productTitleDOM){
    const { renderNewLabel } = labels;
    updatervNewLabel(renderNewLabel , rvProductNewBadgeDOM, rvProductBadgesWrapper, productUnitsSoldWrapperDOM, productTitleDOM);
  }

  function updatervNewLabel(renderNewLabel , rvProductNewBadgeDOM, rvProductBadgesWrapper, productUnitsSoldWrapperDOM, productTitleDOM){
    if (renderNewLabel) {
      if (rvProductBadgesWrapper && !rvProductNewBadgeDOM && rvProductBadgesWrapper?.dataset?.renderNewLabel == "false") {
        rvProductBadgesWrapper.insertAdjacentHTML("afterbegin",
          `<div class="rv-product-card-2-labels__new-badge">
            <p class="ui-badge">NEW</p>
          </div>`
        );
      }
    } else {
      rvProductNewBadgeDOM?.remove();
    }
  }


  function updatedOrCreateMemberPrice(memberPrice, productRedtabMemberPriceDOM, ProductPriceWrapperDOM) {
    if (memberPrice) {
      if (productRedtabMemberPriceDOM) {
        productRedtabMemberPriceDOM.textContent = memberPrice;
      } else {
        ProductPriceWrapperDOM.insertAdjacentHTML("afterend",
          `<p class="product-card-2__redtab-member-price tw-text-[#c41320] tw-font-secondary tw-text-[10px] md:tw-text-[12px] tw-leading-[1]">
          ${memberPrice}
          </p>`
        )
      }
    } else {
      if (productRedtabMemberPriceDOM) {
        productRedtabMemberPriceDOM.remove();
      }
    }
  }

  function udpateOrCreateGstBenefitIncludedTag(renderGstBenefitIncludedTag, gstBenefitTagDOM, productCard, ProductInfoWrapperDOM) {
    if (renderGstBenefitIncludedTag) {
      if (!gstBenefitTagDOM)
        ProductInfoWrapperDOM.insertAdjacentHTML('beforeend',
          `<p class="product-card-2__gst-benefit-included-tag tw-self-start tw-p-[4px] tw-pr-[4px] tw-bg-[#e5e5e5] tw-text-black tw-text-[10px] md:tw-text-[12px] tw-leading-none tw-font-primary tw-rounded">
              GST Benefit INCLUDED
            </p>`
        );
    } else {
      gstBenefitTagDOM?.remove();
    }
  }

  function udpatedOrCreateUnitsSold(unitsSold, productUnitsSoldDOM, productUnitsSoldWrapperDOM, productTitleDOM) {
    if (unitsSold >= 1000) {
      if (productUnitsSoldWrapperDOM && productUnitsSoldDOM) {
        productUnitsSoldDOM.textContent = unitsSold;
      } else {
        productTitleDOM.parentElement.insertAdjacentHTML("beforebegin",
          `<p class="product-card-2__x-units-sold-wrapper ui-badge ui-badge--status">
            <span class="product-card-2__x-units-sold tw-text-[#C41320]">${unitsSold}</span> UNITS SOLD
          </p>`
        )
      }
    } else {
      productUnitsSoldWrapperDOM?.remove();
    }
  }

  function updateProduct(swatchEl, updatedProductDetails) {
    const productCard = swatchEl.closest(`.${PRODUCT_CARD_2.CLASS_SELECTOR.PRODUCT_CARD}`);
    const activeSwatchEl = productCard.querySelector('.product-card-2-swatches__swatch--active');
    const productTitleDOM = productCard.querySelector(`.${PRODUCT_CARD_2.CLASS_SELECTOR.CARD_TITLE}`);
    const productImageDOM = productCard.querySelector(`.${PRODUCT_CARD_2.CLASS_SELECTOR.CARD_IMAGE}`);
    // PRICE
    const ProductInfoWrapperDOM = productCard.querySelector(`.${PRODUCT_CARD_2.CLASS_SELECTOR.CARD_INFO_WRAPPER}`);
    const ProductPriceWrapperDOM = productCard.querySelector(`.${PRODUCT_CARD_2.CLASS_SELECTOR.PRICE_WRAPPER}`);
    const productSalePriceWrapperDOM = ProductPriceWrapperDOM?.querySelector(`.${PRODUCT_CARD_2.CLASS_SELECTOR.SALE_PRICE_WRAPPER}`);
    const productSalePriceDOM = productSalePriceWrapperDOM ? productSalePriceWrapperDOM.querySelector(`.${PRODUCT_CARD_2.CLASS_SELECTOR.SALE_PRICE}`) : null;
    const productOriginalPriceWrapperDOM = ProductPriceWrapperDOM?.querySelector(`.${PRODUCT_CARD_2.CLASS_SELECTOR.ORIGINAL_PRICE_WRAPPER}`);
    const productOriginalPriceDOM = productOriginalPriceWrapperDOM ? productOriginalPriceWrapperDOM.querySelector(`.${PRODUCT_CARD_2.CLASS_SELECTOR.ORIGINAL_PRICE}`) : null;
    const productDiscountWrapperDOM = ProductPriceWrapperDOM?.querySelector(`.${PRODUCT_CARD_2.CLASS_SELECTOR.DISCOUNT_WRAPPER}`);
    const productDiscountDOM = productDiscountWrapperDOM ? productDiscountWrapperDOM.querySelector(`.${PRODUCT_CARD_2.CLASS_SELECTOR.DISCOUNT}`) : null;
    // REDTAB MEMBER PRICE
    const productRedtabMemberPriceDOM = productCard.querySelector(`.${PRODUCT_CARD_2.CLASS_SELECTOR.REDTAB_MEMBER_PRICE}`);
    // GST BENEFIT TAG
    const gstBenefitTagDOM = productCard.querySelector(`.${PRODUCT_CARD_2.CLASS_SELECTOR.GST_BENEFIT_TAG}`);
    // UNITS SOLD
    const productUnitsSoldWrapperDOM = productCard.querySelector(`.${PRODUCT_CARD_2.CLASS_SELECTOR.UNITS_SOLD_WRAPPER}`);
    const productUnitsSoldDOM = productUnitsSoldWrapperDOM ? productUnitsSoldWrapperDOM.querySelector(`.${PRODUCT_CARD_2.CLASS_SELECTOR.UNITS_SOLD}`) : null;
    // LABELS/TAGS
    const productLabelsWrapper = productCard.querySelector(`.${PRODUCT_CARD_2.CLASS_SELECTOR.LABELS_WRAPPER}`);
    const productNewLabelDOM = productLabelsWrapper ? productLabelsWrapper.querySelector(`.${PRODUCT_CARD_2.CLASS_SELECTOR.NEW_LABEL}`) : null;
    const productRedloopLabelDOM = productLabelsWrapper ? productLabelsWrapper.querySelector(`.${PRODUCT_CARD_2.CLASS_SELECTOR.REDLOOP_LABEL}`) : null;
    // RV LABELS/
    const rvProductBadgesWrapper = productCard.querySelector(`.${PRODUCT_CARD_2.CLASS_SELECTOR.RV_LABELS_WRAPPER}`);
    const rvProductNewBadgeDOM = rvProductBadgesWrapper ? rvProductBadgesWrapper.querySelector(`.${PRODUCT_CARD_2.CLASS_SELECTOR.RV_NEW_LABEL}`): null; 
    // QUICK ATC
    const quickAtcBtn = productCard.querySelector("[data-overlay-open]");
    // WISHLIST
    let wishlistBtnhulk = productCard.querySelector(".wishlist-btn");

    if (wishlistBtnhulk) {
      const varId = swatchEl.getAttribute('data-varid');
      wishlistBtnhulk.setAttribute("data-proid", swatchEl.getAttribute('data-proid'));
      wishlistBtnhulk.setAttribute(
          "data-varid",
          varId || ""
      );
      wishlistBtnhulk.setAttribute("data-added", false);
    }


    // console.log(updatedProductDetails);
    if (activeSwatchEl){
      activeSwatchEl.classList.remove("product-card-2-swatches__swatch--active");
    }

    const {
      image,
      labels,
      memberPrice,
      price,
      renderGstBenefitIncludedTag,
      title,
      unitsSold,
      url
    } = updatedProductDetails;

    requestAnimationFrame(() => {
      if (productImageDOM && image) {
        const { src, srcset, alt } = image;
        if (src) {
          const img = new Image();
          img.src = src;
          if (srcset) {
            img.srcset = srcset;
          }
          img.decode().then(() => {
            productImageDOM.src = src;
            productImageDOM.srcset = srcset;
            productImageDOM.alt = alt;
          });
        }
        if (productImageDOM.closest("a")){
          productImageDOM.closest("a").href = url;
        }
      }
      if (title && productTitleDOM) {
        productTitleDOM.textContent = title;
        productTitleDOM.href = url;
      }
      updateQuickATC(url, quickAtcBtn);
      updateOrCreatePrice(price, ProductPriceWrapperDOM, productSalePriceWrapperDOM, productSalePriceDOM, productOriginalPriceWrapperDOM, productOriginalPriceDOM, productDiscountWrapperDOM, productDiscountDOM);
      udpatedOrCreateLabels(labels, productNewLabelDOM, productRedloopLabelDOM ,productLabelsWrapper);
      udpatedOrCreateRvBadges(labels, rvProductNewBadgeDOM, rvProductBadgesWrapper, productUnitsSoldWrapperDOM, productTitleDOM);
      updatedOrCreateMemberPrice(memberPrice, productRedtabMemberPriceDOM, ProductPriceWrapperDOM);
      udpatedOrCreateUnitsSold(unitsSold, productUnitsSoldDOM, productUnitsSoldWrapperDOM, productTitleDOM);
      udpateOrCreateGstBenefitIncludedTag(renderGstBenefitIncludedTag, gstBenefitTagDOM, productCard, ProductInfoWrapperDOM);
    })
    swatchEl.classList.add("product-card-2-swatches__swatch--active");
  }

  function prefetchCardSwatches(swatchEl) {
    const siblingProducts = swatchEl.closest(`.${PRODUCT_CARD_2.CLASS_SELECTOR.CARD_SWATCHES_WRAPPER}`).querySelectorAll("button:not(.product-card-2-swatches__swatch--active)");
    siblingProducts.forEach(eachSwatchEl => {
      prefetchProductData(eachSwatchEl);
    });
  }

  async function onProductCardSwatchClick(swatchEl) {
    const productURL = swatchEl.dataset.url;
    if (!productURL) return;
    const url = `${productURL}?section_id=${PRODUCT_CARD_2.SECTION_ID}`;

    swatchEl.classList.toggle("product-card-2-swatches-swatch--loading");
    const productDetails = await fetchProductData(url);

    prefetchCardSwatches(swatchEl);

    updateProduct(swatchEl, productDetails);
    swatchEl.classList.toggle("product-card-2-swatches-swatch--loading");
  }

  function onSwatchesViewMoreBtnClick(target) {
    const productCardSwatches = target.closest(`.${PRODUCT_CARD_2.CLASS_SELECTOR.CARD_SWATCHES_WRAPPER}`);
    if (!productCardSwatches) return;
    const hiddenSwatches = productCardSwatches.querySelectorAll(`li.${PRODUCT_CARD_2.CLASSNAME_STATE.HIDDEN}`);
    if (hiddenSwatches.length) {
      hiddenSwatches.forEach(el => {
        el.classList.toggle(`${PRODUCT_CARD_2.CLASSNAME_STATE.HIDDEN}`);
      });
    }
    target.remove();
  }

  function onClickHandler(e) {
    const target = e.target;
    if (target.matches(`.${PRODUCT_CARD_2.SWATCH_TRIGGER}`) || target.closest(`.${PRODUCT_CARD_2.SWATCH_TRIGGER}`)) {
      let swatchEl = target.matches(`.${PRODUCT_CARD_2.SWATCH_TRIGGER}`) ? target : target.closest(`.${PRODUCT_CARD_2.SWATCH_TRIGGER}`);
      if (swatchEl.classList.contains("product-card-2-swatches__swatch--active")){
        return;
      }
      onProductCardSwatchClick(swatchEl);
    }
    if (target.matches(`.${PRODUCT_CARD_2.CLASS_SELECTOR.SWATCHES_VIEW_MORE}`)) {
      onSwatchesViewMoreBtnClick(target);
    }
  }

  function onHoverHandler(e) {
    const target = e.target;
    if (target.matches(`.${PRODUCT_CARD_2.SWATCH_TRIGGER}`) || target.closest(`.${PRODUCT_CARD_2.SWATCH_TRIGGER}`)) {
      let swatchEl = target.matches(`.${PRODUCT_CARD_2.SWATCH_TRIGGER}`) ? target : target.closest(`.${PRODUCT_CARD_2.SWATCH_TRIGGER}`);
      prefetchProductData(swatchEl);
    }
  }

  document.addEventListener("click", onClickHandler);
  document.addEventListener("pointerover", onHoverHandler, {
    passive: true
  });
})();